import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { ArrowLeftIcon2 } from "assets/icons";
import Layout from "components/layout";
import Ticket from "./ticket";
import FoodBeverage from "./foodBeverage";
import Payment from "./payment";
import {
  setTicketActiveStep,
  setOpenTicketDetail,
  setActiveSection,
} from "../../redux/reducers/bookingReducer";

const steps = [
  {
    label: "Tickets",
    value: 1,
  },
  {
    label: "Food & Beverage",
    value: 2,
  },
  {
    label: "Payment",
    value: 3,
  },
];

function Checkout() {
  const dispatch = useDispatch();
  const { busDetail, booking } = useSelector((state) => state.bookingReducer);
  const [activeStep, setActiveStep] = useState(steps[0].value);

  const handleBack = (e) => {
    if (activeStep === 1) {
      e.stopPropagation();
      dispatch(setTicketActiveStep(2));
      dispatch(setOpenTicketDetail(true));
      dispatch(setActiveSection("search-buses"));
    } else {
      setActiveStep((prev) => prev - 1);
    }
  };

  console.log("booking...", booking);
  console.log("busDetail...", busDetail);

  return (
    <Layout showMobileHeader={false} showBottomTab={false}>
      <div className="w-full flex flex-col items-center">
        <div className="w-full max-w-8xl margins flex flex-col">
          <button
            onClick={handleBack}
            className="py-6 md:py-10 flex items-center gap-2 sm:gap-5"
          >
            <span className="h-3 sm:h-4 w-3 sm:w-4">
              <ArrowLeftIcon2 />
            </span>
            <div className="text-sm sm:text-lg font-semibold text-[#112211]">
              Back
            </div>
          </button>
          {/* <div className="w-full md:max-w-[500px] flex items-center justify-between relative mb-10">
            <div className="w-full flex max-w-[82%] sm:max-w-[90%] md:max-w-[81%] h-[3px] bg-primary-700/10 absolute z-0 top-[12px] left-11">
              <div
                className={`h-full bg-primary-700 animation ${
                  activeStep === 2
                    ? "w-[50%]"
                    : activeStep === 3
                    ? "w-[100%]"
                    : ""
                }`}
              />
            </div>
            {steps.map((step, index) => (
              <div
                key={index}
                className="flex flex-col items-center gap-3 z-[1"
              >
                <div
                  className={`h-6 sm:h-[27px] w-6 sm:w-[27px] border-[1px] border-primary-700 rounded-[4px] flex items-center justify-center rotate-45 animation ${
                    activeStep === step.value || activeStep > step.value
                      ? "bg-primary-700 text-white"
                      : "bg-white text-primary-700"
                  }`}
                >
                  <span className="text-[12px] sm:text-sm -rotate-45">
                    {step.value}
                  </span>
                </div>
                <div className="text-[12px] sm:text-sm md:text-base text-[#4F4F4F] font-semibold">
                  {step.label}
                </div>
              </div>
            ))}
          </div> */}
          {activeStep === 1 && (
            <Ticket
              setActiveStep={setActiveStep}
              busDetail={busDetail}
              booking={booking}
            />
          )}
          {activeStep === 2 && <FoodBeverage setActiveStep={setActiveStep} />}
          {activeStep === 3 && <Payment setActiveStep={setActiveStep} />}
        </div>
      </div>
    </Layout>
  );
}
export default Checkout;
